import React from 'react';
import { TFunction } from 'i18next';
import Table from 'antd/es/table';
import { CheckSquare, Square } from 'react-feather';

type ChangedValueProps = {
  changes: any;
  t: TFunction;
};

const renderValue = (value: any) => {
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch (e) {
      return '[Complex Object]';
    }
  }
  if (typeof value === 'boolean')
    return value ? <CheckSquare size={16} /> : <Square size={16} />;
  return value;
};

const columns = (t: TFunction) => [
  {
    title: t('Action'),
    dataIndex: 'action',
    key: 'action',
    width: 165,
  },
  {
    title: t('Field'),
    dataIndex: 'field',
    key: 'field',
    width: 165,
  },
  {
    title: t('Old Value'),
    dataIndex: 'oldValue',
    key: 'oldValue',
    render: renderValue,
  },
  {
    title: t('New Value'),
    dataIndex: 'newValue',
    key: 'newValue',
    render: renderValue,
  },
];

const formatData = (changes: any[]) => {
  return changes.map((x, index) => {
    let [action, field, [oldValue, newValue]] = x;

    if (field instanceof Array) field = `${field[0]}[${field[1]}]`;

    if (oldValue instanceof Array) oldValue = oldValue[1];
    if (action === 'add') {
      [oldValue, newValue] = [newValue, oldValue];
    }

    return {
      index,
      action,
      field,
      oldValue,
      newValue,
    };
  });
};

export default function ChangedValues({ changes, t }: ChangedValueProps) {
  return (
    <Table
      dataSource={formatData(changes)}
      columns={columns(t)}
      rowKey={'index'}
      pagination={false}
      onRow={() => ({
        className: 'cursor-pointer bg-[#fafafa]',
      })}
    />
  );
}
